export class Tile {
    Title: string = null;
    Color: string = null;
    Url: string = null;
    Target: string = null;
    Login = false;
    Service: any = null;
    TodayUrl = '';
    TotalUrl = '';
    KPITitles: any = ['TOTAL', 'TODAY'];
    KPIs: KPI[] = [];

    public constructor(init?: Partial<Tile>) {
        Object.assign(this, init);
    }
}

export class KPI {
    KPITitle: string = null;
    Url: string = null;
    Service?: any = null;

    public constructor(init?: Partial<KPI>) {
        Object.assign(this, init);
    }
}
